import {
  FETCH_USER_SUCCESS,
  FETCH_USER_COMPANIES_SUCCESS,
  CHANGE_COMPANY, FETCH_VESSEL_WATCHlIST_SUCCESS,
  FETCH_USER_SETTING_SUCCESS
} from '../action/user.action';

const initialState = {
  id: null,
  name: "",
  email: "",
  phone: "",
  premium: false,
  companies: [],
  companyId: null,
  company: {},
  myFleets: [],
  settings: {}
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_SETTING_SUCCESS:
      let settings = {}
      if (action.payload['BUSINESS_GENERATOR_COLOR_FOR']) {
        settings.colorFor = action.payload['BUSINESS_GENERATOR_COLOR_FOR'];
      }
      if (action.payload['BUSINESS_GENERATOR_SHOW_ACTUAL_VESSEL_POSITION']) {
        settings.actualVesselPosition = ('true' === action.payload['BUSINESS_GENERATOR_SHOW_ACTUAL_VESSEL_POSITION'])
      }
      if (action.payload['BUSINESS_GENERATOR_HEATMAP_MONTHS']) {
        settings.heatmapMonths = action.payload['BUSINESS_GENERATOR_HEATMAP_MONTHS'];
      }
      if (action.payload['DASHBOARD_CURRENT_COMPANY_ID']) {
        settings.dashboardCurrentCompanyId = action.payload['DASHBOARD_CURRENT_COMPANY_ID'];
      }
      return {
        ...state,
        settings
      }
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        name: action.payload.name,
        email: action.payload.email,
      };
    case FETCH_USER_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.payload
      }
    case CHANGE_COMPANY:
      state.companyId = action.companyId
      state.company = action.company
      return {
        ...state,
        company: state.company,
        companyId: action.companyId,
      }
    case FETCH_VESSEL_WATCHlIST_SUCCESS:
      return {
        ...state,
        myFleets: action.payload
      }
    default:
      return state;
  }
}